angular.module('bmsApp.directives')
	.directive('complaintsGeneric', [
		'$modal',
		'$ngBootbox',
		'notify',
		'ComplaintSvc',
		'ConfigService', function (
			$modal,
			$ngBootbox,
			notify,
			ComplaintSvc,
			ConfigService) {
			return {
				restrict: 'E',
				scope: {
					params: '=',
					allowAdd: '=',
					showObjectViewLink: '=',
				},
				replace: true,
				templateUrl: 'ng/complaints/templates/Complaints.html',
				link: function (scope, element, attrs) {
				},
				controller: function ($scope, $rootScope) {
					$scope.load = function (){
						$scope.loading = true;
						ComplaintSvc.index($scope.params).then(function (response){
							$scope.isSM = $rootScope.isSM;
							$scope.isMM = $rootScope.isMM;
							$scope.complaints = response.data.complaint_collection;
							$rootScope.$broadcast('complaintsLoaded');
							$scope.loading = false;
						});
					}
					$scope.load();

					$scope.showComplaintForm = function (complaint) {
						ComplaintSvc.showSaveModal(complaint, false).then(function(result){
						});
					};
					$rootScope.$on('complaintsUpdated', function (evt, counts) {
						$scope.load();
					});

					$scope.showComplaintNoteForm = function (complaintNote, complaint) {
						var modalInstance = $modal.open({
							animation: true,
							templateUrl: 'ng/complaints/templates/ComplaintNoteForm.html',
							controller: 'ComplaintNoteFormCtrl',
							size: 'lg',
							scope: $scope,
							backdrop: 'static', // disable click-outside closing modal
							resolve: {
								complaintNote: function () {
									var newComplaintNote = {};
									if (complaintNote) {
										angular.extend(newComplaintNote, angular.copy(complaintNote));
									}
									angular.extend(newComplaintNote, {
										complaint: complaint,
									});
									return newComplaintNote;
								}
							}
						});

						modalInstance.result.then(function (result) {
							if (result.success) {
								switch (result.action) {
									case 'create':
										message = 'Comment added successfully';
										break;
									case 'update':
										message = 'Comment updated successfully';
										break;
									default:
										message = 'Success';
										break;
								}
								notify({
									message: message
								});
								$scope.load();
								// $scope.$broadcast('complaintUpdated');
							}
							else {
								notify({
									message: result.error,
									classes: 'error'
								});
							}
						}, function () {
							// closed
						});

					};

					$scope.complaintDelete = function (complaint) {
						$ngBootbox.confirm('Delete complaint "' + complaint.subject + '"?')
							.then(function () {
								ComplaintSvc.delete(complaint)
									.then(function (response) {
										notify({
											message: 'Complaint deleted successfully'
										});
										// $scope.$broadcast('complaintUpdated');
										$scope.load();
									}, function (error) {
										notify({
											message: error,
											classes: 'error'
										});
										$log.error(error);
									});
							});
					};

				}
			};
		}]);
